
import { equalArrays } from "../../utils/equalArrays";
import {
  ADD_CONTRACT_PRODUCT_TO_CART,
  DELETE_CONTRACT_PRODUCT_FROM_CART,
  ADD_CONTRACT_SUCCESS,
  ADD_CONTRACT,
  EDIT_CONTRACT_SUCCESS,
  EDIT_CONTRACT,
  EMPTY_CONTRACT_PRODUCT_CART,
  CHANGE_CONTRACT_PAGE,
  STORE_CONTRACT,
  ADD_CONTRACT_DISC,
  GET_ALL_CONTRACTS
  , DELETE_CONTRACT_SUCCESS,
  GET_CONTRACT_SUCCESS,
  STORE_CONTRACT_PRODUCTS,
  EMPTY_CONTRACT,
  CALCULATE_CONTRACT_TAX,
  GET_CONTRACT,
  CHANGE_CONTRACT_PRODUCT_LOADER,
  DELETE_CONTRACT,
  SET_VIEW,
  SET_CONTRACT_SELECTED_REASON,
  ADD_CONTRACT_STATUS_SUCCESS,
  ADD_CONTRACT_STATUS,
  DELETE_CONTRACT_STATUS,
  GET_ALL_CONTRACT_STATUS_SUCCESS,
  GET_ALL_CONTRACT_STATUS,
  GET_CONTRACT_STATUS_SUCCESS,
  GET_CONTRACT_STATUS,
  UPDATE_CONTRACT_STATUS_SUCCESS,
  UPDATE_CONTRACT_STATUS,
  DELETE_CONTRACT_STATUS_SUCCESS,
  GET_ALL_CONTRACT_STATUS_LIST,
  GET_ALL_CONTRACT_LOST_REASON,
  GET_ALL_CONTRACT_LOST_REASON_SUCCESS,
  GET_ALL_CONTRACT_LOST_REASON_LIST,
  GET_CONTRACT_LOST_REASON,
  GET_CONTRACT_LOST_REASON_SUCCESS,
  DELETE_CONTRACT_LOST_REASON,
  DELETE_CONTRACT_LOST_REASON_SUCCESS,
  ADD_CONTRACT_LOST_REASON,
  ADD_CONTRACT_LOST_REASON_SUCCESS,
  UPDATE_CONTRACT_LOST_REASON,
  UPDATE_CONTRACT_LOST_REASON_SUCCESS,
  GET_ALL_CONTRACTS_FILTER,
  GET_ALL_CONTRACTS_FILTER_SUCCESS,
  SET_CONTRACT_FILTERS,
  GET_CONTRACT_USERS,
  GET_CONTRACT_PARAMETERS,
  GET_CONTRACT_PARAMETERS_LIST,
  GET_CONTRACT_PARAMETERS_SUCCESS,
  EDIT_CONTRACT_PARAMETERS,
  EDIT_CONTRACT_PARAMETERS_SUCCESS,
} from "../actions/Contracts.action";

const initialState = {
  addContractStatusLoading: false,
  getContractStatusesLoading: false,
  getContractStatusLoading: false,
  updateContractStatusLoading: false,
  deleteContractStatusLoading: false,

  addContractLostReasonLoading: false,
  getContractLostReasonsLoading: false,
  getContractLostReasonLoading: false,
  updateContractLostReasonLoading: false,
  deleteContractLostReasonLoading: false,
  getParametersLoading: false,
  editParametersLoading: false,
  contractStatus: [],
  contractStatusList: [],
  currentContractStatus: "",
  currentReason: "",
  addedStatus: "",
  addedReason: "",

  salesmen: [],
  users: [],
  selectedReason: null,
  reasons: [],
  reasonsList: [],
  products: [],
  contracts: {},
  subTotal: 0,
  discount: 0,
  cost: 0,
  productLoader: false,
  addContractLoading: false,
  getContractLoading: false,
  getContractsLoading: false,
  getContractsFilterLoading: false,
  editContractLoading: false,
  contractData: {},
  tax: [],
  page: 1,
  invoiceDisc: { percentageDiscount: 0, amountDiscount: 0 },
  currentContract: {},
  flag: false,
  view: true,
  max: 0,
  min: 0,
  sum: 0,
  parametersList: [],
  parameters: [],



};
let taxes = [];
const RESET_LOADING = "RESET_LOADING"
function branch(state = initialState, action) {
  switch (action.type) {
    case RESET_LOADING:
      return Object.assign({}, state, {

        addContractStatusLoading: false,
        getContractStatusesLoading: false,
        getContractStatusLoading: false,
        updateContractStatusLoading: false,
        deleteContractStatusLoading: false,

        addContractLostReasonLoading: false,
        getContractLostReasonsLoading: false,
        getContractLostReasonLoading: false,
        updateContractLostReasonLoading: false,
        deleteContractLostReasonLoading: false,

        productLoader: false,
        addContractLoading: false,
        getContractLoading: false,
        getContractsLoading: false,
        getContractsFilterLoading: false,
        editContractLoading: false,
        getParametersLoading: false,
        editParametersLoading: false,


      })
    case SET_VIEW:
      return Object.assign({}, state, {
        view: action.payload.view,
      });
    case SET_CONTRACT_FILTERS:
      return Object.assign({}, state, {
        filters: action.payload.filters,
      });
    case SET_CONTRACT_SELECTED_REASON:
      return Object.assign({}, state, {
        selectedReason: action.payload.selectedReason,
      });
    case GET_CONTRACT_USERS:
      return Object.assign({}, state, {
        users: action.payload.users,
        salesmen: action.payload.salesmen
      });
    case ADD_CONTRACT_PRODUCT_TO_CART:
      const productIndex = state.products.findIndex((product) => product.id === action.payload.product.id);
      let match = false;
      let newTotalQty = action.payload.product?.qty + action.payload.product?.linkedCustomers?.reduce((acc, obj) => acc + obj.qty, 0);

      taxes = [...state.tax]
      //edit
      if (productIndex !== -1) {
        const updatedProducts = [...state.products];
        if (
          action.payload.product.price === updatedProducts[productIndex]?.price &&
          action.payload.product.discount === updatedProducts[productIndex]?.discount &&
          action.payload.product.qty === updatedProducts[productIndex]?.qty &&
          action.payload.product.remark === updatedProducts[productIndex]?.remark &&
          action.payload.product.validity === updatedProducts[productIndex]?.validity &&
          equalArrays(action.payload.product.linkedCustomers, updatedProducts[productIndex]?.linkedCustomers)
        ) {
          match = true
        }

        let oldTotalQty = updatedProducts[productIndex]?.qty + updatedProducts[productIndex]?.linkedCustomers?.reduce((acc, obj) => acc + obj.qty, 0);

        if (!match) {
          state.subTotal -= parseFloat(oldTotalQty * updatedProducts[productIndex]?.price)
          state.cost -= parseFloat(oldTotalQty * updatedProducts[productIndex]?.unitCost * ((updatedProducts[productIndex]?.validity || 12) / 12))
          state.discount -= parseFloat(updatedProducts[productIndex]?.discount)

          updatedProducts[productIndex]?.newTaxes.forEach((obj) => {
            const { taxUuid, taxAmount } = obj;
            const index = taxes.findIndex(t => t.taxUuid === taxUuid)
            if (index != -1) {
              taxes[index].taxAmount -= taxAmount;
            }
            else {
              taxes.push({ taxUuid: taxUuid, taxAmount: taxAmount })
            }
          });

          updatedProducts[productIndex] = {
            ...action.payload.product
          };

          state.subTotal += parseFloat(newTotalQty * action.payload.product?.price)
          state.cost += parseFloat(newTotalQty * action.payload.product?.unitCost * ((action.payload.poduct?.validity || 12) / 12))
          state.discount += parseFloat(action.payload.product?.discount);

          action.payload.product?.newTaxes.forEach((obj) => {
            const { taxUuid, taxAmount } = obj;
            const index = taxes.findIndex(t => t.taxUuid === taxUuid)
            if (index !== -1) {
              taxes[index].taxAmount += taxAmount;
            }
            else {
              taxes.push({ taxUuid: taxUuid, taxAmount: taxAmount })
            }
          });
          state.tax = [...taxes];

          return {
            ...state,
            products: updatedProducts
          };
        }
        else {
          return {
            ...state
          };
        }

      }
      //add
      else {

        state.subTotal += parseFloat(newTotalQty * action.payload.product?.price)
        state.cost += parseFloat(newTotalQty * action.payload.product?.unitCost * ((action.payload.product?.validity || 12) / 12))
        state.discount += parseFloat(action.payload.product?.discount);

        action.payload.product?.newTaxes.forEach((obj) => {
          const { taxUuid, taxAmount } = obj;
          const index = taxes.findIndex(t => t.taxUuid === taxUuid)
          if (index != -1) {
            taxes[index].taxAmount += taxAmount;
          }
          else {
            taxes.push({ taxUuid: taxUuid, taxAmount: taxAmount })
          }
        });

        state.tax = [...taxes];

        return {
          ...state,
          products: [...state.products, action.payload.product]
        };
      }

    case DELETE_CONTRACT_PRODUCT_FROM_CART:

      taxes = [...state.tax];
      const oldProducts = [...state.products];
      const index = oldProducts.findIndex((prod) => prod.id === action.payload.id);
      const totalQty = oldProducts[index].qty + oldProducts[index].linkedCustomers.reduce((acc, obj) => acc + obj.qty, 0);

      state.subTotal -= parseFloat(totalQty * oldProducts[index]?.price)
      state.cost -= parseFloat(totalQty * oldProducts[index]?.unitCost * ((oldProducts[index]?.validity || 12) / 12))
      state.discount -= parseFloat(oldProducts[index]?.discount);

      oldProducts[index]?.newTaxes.forEach((obj) => {
        const { taxUuid, taxAmount } = obj;
        const index = taxes.findIndex(t => t.taxUuid === taxUuid)
        if (index !== -1) {
          taxes[index].taxAmount -= taxAmount;
        }
      });
      const updatedProducts = state.products.filter((product) => product.id !== action.payload.id);

      if (updatedProducts?.length === 0) {
        state.invoiceDisc = { percentageDiscount: 0, amountDiscount: 0 }
      }
      return {
        ...state,
        products: updatedProducts,
      };
    case EMPTY_CONTRACT_PRODUCT_CART:
      return Object.assign({}, state, {
        subTotal: 0,
        products: [],
        cost: 0,
        tax: [],
        discount: 0,
        contractData: {},
        invoiceDisc: { percentageDiscount: 0, amountDiscount: 0 }
      });

    case ADD_CONTRACT_SUCCESS:
      return Object.assign({}, state, {
        contracts: { data: action.payload.contracts },
      });
    case ADD_CONTRACT:
      return Object.assign({}, state, {
        addContractLoading: action.payload.addContractLoading
      });
    case EDIT_CONTRACT_SUCCESS:

      return Object.assign({}, state, {
        currentContract: action.payload.editedContract
      });
    case EDIT_CONTRACT:
      return Object.assign({}, state, {
        editContractLoading: action.payload.editContractLoading
      });
    case GET_CONTRACT_SUCCESS:
      return Object.assign({}, state, {
        currentContract: action.payload.contract,
      });
    case GET_CONTRACT:
      return Object.assign({}, state, {
        getContractLoading: action.payload.getContractLoading
      });

    case DELETE_CONTRACT_SUCCESS:
      return Object.assign({}, state, {
        contracts: action.payload.contracts,
      });
    case GET_ALL_CONTRACTS:
      return Object.assign({}, state, {
        getContractsLoading: action.payload.getContractsLoading,
      });

    case GET_ALL_CONTRACTS_FILTER_SUCCESS:
      let oldContracts = [];

      if (action.payload.page === 1 || !action.payload.view)
        oldContracts = [];

      else {
        oldContracts = [...state?.contracts?.newContracts];
      }

      return Object.assign({}, state, {
        contracts: {
          newContracts: action.payload.contracts,
          oldContracts: [...oldContracts],
          totalRecords: action.payload.totalRecords,
          totalPages: action.payload.totalPages,
          page: action.payload.page,
          sum: action.payload.sum,
          min: action.payload.min,
          max: action.payload.max
        }
      });
    case GET_ALL_CONTRACTS_FILTER:
      return Object.assign({}, state, {
        getContractsFilterLoading: action.payload.getContractsFilterLoading,
      });
    case CALCULATE_CONTRACT_TAX:
      taxes = []
      action.payload?.data?.forEach((product) => {

        product?.newTaxes.forEach((obj) => {
          const { taxUuid, taxAmount } = obj;
          const index = taxes.findIndex(t => t.taxUuid === taxUuid)
          if (index !== -1) {
            taxes[index].taxAmount += taxAmount;
          }
          else {
            taxes.push({ taxUuid: taxUuid, taxAmount: taxAmount })
          }
        });

      })

      return Object.assign({}, state, {
        tax: taxes,
      });

    case ADD_CONTRACT_DISC:
      return Object.assign({}, state, {
        invoiceDisc: action.payload.invoiceDisc,
      });
    case STORE_CONTRACT:
      return Object.assign({}, state, {
        contractData: action.payload.data,
      });
    case CHANGE_CONTRACT_PRODUCT_LOADER:
      return Object.assign({}, state, {
        productLoader: action.payload.productLoader,
      });
    case EMPTY_CONTRACT:
      return Object.assign({}, state, {
        contractData: {},
      });
    case STORE_CONTRACT_PRODUCTS:
      taxes = [];
      action.payload?.data?.contractDetails?.forEach((obj) => {
        const { contractDetailsTaxes } = obj;
        contractDetailsTaxes?.forEach((t) => {
          const { amount, tax } = t;
          const index = taxes.findIndex(o => o.taxUuid == tax.uuid)

          if (index != -1) {
            taxes[index].taxAmount += amount;
          }
          else {
            taxes.push({ taxUuid: tax.uuid, taxAmount: amount })
          }


        })


      });
      return Object.assign({}, state, {
        products: action.payload.data.contractDetails,
        subTotal: action.payload.data.subtotal,
        discount: action.payload.data.discount,
        cost: action?.payload?.data?.cost,
        tax: taxes,

      });

    case CHANGE_CONTRACT_PAGE:
      return Object.assign({}, state, {
        page: action.payload.page,
        flag: action.payload.flag
      });

    case ADD_CONTRACT_STATUS_SUCCESS:
      return Object.assign({}, state, {
        contractStatus: action.payload.contractStatus,
        addedStatus: action.payload.addedStatus

      });
    case ADD_CONTRACT_STATUS:
      return Object.assign({}, state, {
        addContractStatusLoading: action.payload.addContractStatusLoading,
      });

    case GET_ALL_CONTRACT_STATUS_SUCCESS:
      return Object.assign({}, state, {
        contractStatus: action.payload.contractStatus,
        currentContractStatus: "",
      });

    case GET_ALL_CONTRACT_STATUS_LIST:
      return Object.assign({}, state, {
        contractStatusList: action.payload.contractStatusList,
        currentContractStatus: "",
      });
    case GET_ALL_CONTRACT_STATUS:
      return Object.assign({}, state, {
        getContractStatusesLoading: action.payload.getContractStatusesLoading,

      });

    case GET_CONTRACT_STATUS_SUCCESS:
      return Object.assign({}, state, {
        currentContractStatus: action.payload.currentContractStatus,
      });
    case GET_CONTRACT_STATUS:
      return Object.assign({}, state, {
        geContractStatusLoading: action.payload.getContractStatusLoading,
      });


    case UPDATE_CONTRACT_STATUS_SUCCESS:
      return Object.assign({}, state, {
        contractStatus: action.payload.contractStatus,
      });

    case UPDATE_CONTRACT_STATUS:
      return Object.assign({}, state, {
        updateContractStatusLoading: action.payload.updateContractStatusLoading,
      });

    case DELETE_CONTRACT_STATUS_SUCCESS:
      return Object.assign({}, state, {
        contractStatus: action.payload.contractStatus,
      });
    case DELETE_CONTRACT_STATUS:
      return Object.assign({}, state, {
        deleteContractStatusLoading: action.payload.deleteContractStatusLoading,
      });

    case ADD_CONTRACT_LOST_REASON_SUCCESS:
      return Object.assign({}, state, {
        reasons: action.payload.reasons,
        addedReason: action.payload.addedReason

      });
    case ADD_CONTRACT_LOST_REASON:
      return Object.assign({}, state, {
        addContractLostReasonLoading: action.payload.addContractLostReasonLoading,
      });

    case GET_ALL_CONTRACT_LOST_REASON_SUCCESS:
      return Object.assign({}, state, {
        reasons: action.payload.reasons,
      });

    case GET_ALL_CONTRACT_LOST_REASON_LIST:
      return Object.assign({}, state, {
        reasonsList: action.payload.reasonsList,
      });
    case GET_ALL_CONTRACT_LOST_REASON:
      return Object.assign({}, state, {
        getContractLostReasonsLoading: action.payload.getContractLostReasonsLoading,

      });

    case GET_CONTRACT_LOST_REASON_SUCCESS:
      return Object.assign({}, state, {
        currentReason: action.payload.currentReason,
      });
    case GET_CONTRACT_LOST_REASON:
      return Object.assign({}, state, {
        geContractLostReasonLoading: action.payload.getContractLostReasonLoading,
      });


    case UPDATE_CONTRACT_LOST_REASON_SUCCESS:
      return Object.assign({}, state, {
        reasons: action.payload.reasons,
      });

    case UPDATE_CONTRACT_LOST_REASON:
      return Object.assign({}, state, {
        updateContractLostReasonLoading: action.payload.updateContractLostReasonLoading,
      });

    case DELETE_CONTRACT_LOST_REASON_SUCCESS:
      return Object.assign({}, state, {
        reasons: action.payload.reasons,
      });
    case DELETE_CONTRACT_LOST_REASON:
      return Object.assign({}, state, {
        deleteContractLostReasonLoading: action.payload.deleteContractLostReasonLoading,
      });

    case GET_CONTRACT_PARAMETERS_SUCCESS:
      return Object.assign({}, state, {
        parameters: action.payload.parameters,
        headerLogoUrl: action?.payload?.parameters?.headerInfo?.logo,
        footerLogoUrl: action?.payload?.parameters?.footerInfo?.logo,

      });

    case GET_CONTRACT_PARAMETERS_LIST:
      return Object.assign({}, state, {
        parametersList: action.payload.parametersList,
        headerLogoUrl: action?.payload?.parametersList?.headerInfo?.logo,
        footerLogoUrl: action?.payload?.parametersList?.footerInfo?.logo,

      });

    case GET_CONTRACT_PARAMETERS:
      return Object.assign({}, state, {
        getParametersLoading: action.payload.getParametersLoading
      });

    case EDIT_CONTRACT_PARAMETERS_SUCCESS:
      return Object.assign({}, state, {
        parameters: action.payload.parameters
      });

    case EDIT_CONTRACT_PARAMETERS:
      return Object.assign({}, state, {
        editParametersLoading: action.payload.editParametersLoading
      });

    default:
      return state;
  }

}

export default branch;
